<template>
  <transition 
    @appear="enterNav"         
    @enter="enterNav" 
    @leave="leaveNav">
    <div v-show="sections[activeSection].navigation !== false">
        <div class="homePageSectionNav">
            <ul>
                <li 
                  v-for="(section) in currentSectionsType" 
                  :key='section.name'
                  class="navCircle"
                  :style="{ backgroundColor: sections[activeSection].navColor }"
                  @click="changeActiveSection(section.absoluteIndex, section.relativeIndex)"
                  @mouseenter="activeSectionName = section.name; showActiveSectionName = true"
                  @mouseleave="showActiveSectionName = false"> 
                </li>
                <li class="activeDot" :style="{ 
                  transform:  cssTranslatePropertyValue,
                  backgroundColor: sections[activeSection].activeNavDotColor }"
                  @mouseenter="activeSectionName = sections[activeSection].name; showActiveSectionName = true"
                  @mouseleave="showActiveSectionName = false">
                </li>
            </ul>
            <span class="navigationSectionTitle" v-bind:class="{ black: !isWhite }">
              <span class="text-wrap">
                <transition 
                  @appear="enterSectionName"          
                  @enter="enterSectionName" 
                  @leave="leaveSectionName"
                  appear>

                    <span v-show="showActiveSectionName" :key='"asdasdasdasdsad"'> {{ activeSectionName }}  </span>

                </transition>
              </span>
            </span>
        </div>
        <div class="homePageSectionsCounterContainer" v-bind:class="{ white: isWhite }">
            <span class="homePageSectionsCounter">           
              <span class="text-wrap">
                <transition appear mode="out-in"
                  @appear="enterNavText"         
                  @enter="enterNavText" 
                  @leave="leaveNavText">
                    <div v-show="showChild">
                      <span class="currentSection">{{ addZeroBeforeSingleNumber(this.counterActiveNumber + 1) }}</span>
                    </div>
                </transition>
              </span>  
              <span class="slash">/</span>
              <span class="allSections">{{ addZeroBeforeSingleNumber(currentSectionsType.length) }}</span>
            </span>
        </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "HomePageSectionNav",
  data() {
    return {
      activeSectionName: "",
      showActiveSectionName: false,
      cssTranslatePropertyValue: "",
      counterActiveNumber: ""
    };
  },
  methods: {
    counterActive: function() {

      setTimeout(() => {

        this.counterActiveNumber = this.sections[this.activeSection].relativeIndex;

      }, 300);

    },

    changeActiveSection: function(absoluteIndex, relativeIndex) {

      // this.active = absoluteIndex;
      this.$emit("changeActiveSection", absoluteIndex);
      this.moveActiveDot(relativeIndex);

    },

    moveActiveDot: function(index) {

      var activeDotOffset = 10 + index * 18; //li margin: 12 + li width: 6
      this.cssTranslatePropertyValue = "translateX(" + activeDotOffset + "px)";

    },

    addZeroBeforeSingleNumber: function(number) {

      var s = String(number);
      if (s.length < 2) {

        s = "0" + s;

      }
      return s;

    },

    enterText: function(el, done) {

      TweenMax.fromTo( el, 1,
        { y: "105%" },
        {
          y: "0%",
          onComplete: done
        });
    },
    leaveText: function(el, done) {

      TweenMax.to( el, 1, 
      {
        y: "-105%",
        onComplete: done
      });

    },
    enterNavText: function(el, done) {

      TweenMax.fromTo( el, 1,
        { y: "205%" },
        {
          y: "0%",
          onComplete: done
        });
    },
    leaveNavText: function(el, done) {

      TweenMax.to( el, 1, 
      {
        y: "-205%",
        onComplete: done
      });

    },
    enterNav: function(el, done) {

      TweenMax.fromTo( el, 1,
        { opacity: 0},
        { 
          opacity: 1,
          delay:0.5,
          onComplete: done
        });

    },
    leaveNav: function(el, done) {

      TweenMax.to( el, 1, 
      {
        opacity: 0,
        onComplete: done
      });
    },
    enterSectionName: function(el, done) {

      TweenMax.fromTo( el, .41,
        { y: "105%" },
        {
          y: "0%",
          onComplete: done
        });

    },
    leaveSectionName: function(el, done) {

      TweenMax.to( el, .41, 
      {
        y: "-105%",
        onComplete: done
      });

    },
  },
  mounted() {

    // this.moveActiveDot;

  },
  computed: {
    currentSectionsType: function() {

      let i = 0;
      return this.sections
      .filter( section => section.sectionType === this.sections[this.activeSection].sectionType );
      
    }
  },
  watch: {
    activeSection: function() {

      var _this = this;
      _this.counterActive();
      _this.moveActiveDot(_this.sections[_this.activeSection].relativeIndex);

    }
  },
  props: ["sections", "activeSection", "showChild", "isWhite"]
};
</script>



// WEBPACK FOOTER //
// src/components/small-components/HomePageSectionsNav.vue